import { PaymentStatus } from '../../apis/payment/PaymentStatus';

export const PaymentService = {
  status: async (placeId: number) => {
    return await PaymentStatus(placeId);
  },
};
